// === CSS
import '../../sass/components/promo-badge.scss'

// Pastille promo : la croix la masque pour le reste de la visite (session navigateur)
const STORAGE_KEY = 'hotelbusby.promoBadge.closed'

document.addEventListener('DOMContentLoaded', () => {
  const badgeEl = document.getElementById('promo-badge')
  if (!badgeEl) {
    return
  }

  try {
    if (sessionStorage.getItem(STORAGE_KEY)) {
      return
    }
  } catch (e) {
    // stockage indisponible (navigation privée…) : on affiche quand même
  }

  badgeEl.classList.add('is-visible')

  badgeEl.querySelector('.promo-badge-close').addEventListener('click', () => {
    badgeEl.classList.remove('is-visible')
    try {
      sessionStorage.setItem(STORAGE_KEY, '1')
    } catch (e) {
      // rien à faire : la pastille reviendra à la page suivante
    }
  })
})
